import styled from 'styled-components';
import { fromMd } from '../../constants';
import { Skeleton } from '../Skeleton';
export const MediaSkeleton = styled(Skeleton).attrs({ animated: true }) `
  aspect-ratio: 3 / 4;
  height: auto;
`;
export const WrapperSkeleton = styled.div ``;
export const OverlineSkeleton = styled(Skeleton) `
  margin-top: ${o => o.theme.spacing(2)};
  height: ${o => o.theme.spacing(3.75)};
  ${fromMd} {
    height: ${o => o.theme.spacing(4.5)};
  }
`;
export const TitleSkeleton = styled(Skeleton) `
  margin-top: ${o => o.theme.spacing(4)};
  height: ${o => o.theme.spacing(5)};
`;
export const DetailsSkeleton = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: ${o => o.theme.spacing(2)};
  gap: ${o => o.theme.spacing(2)};
`;
//# sourceMappingURL=ProductCardSkeleton.js.map